const FAVORITES_STORAGE_KEY = 'favorite_product_catalog_ids';
export const MAX_FAVORITES = 20;

export function getFavoriteProductCatalogIds(): number[] {
  if (typeof window === 'undefined' || !window.eventsTracking) return [];
  try {
    const raw = window.eventsTracking.getData(FAVORITES_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((id): id is number => typeof id === 'number' && Number.isInteger(id))
      : [];
  } catch {
    return [];
  }
}

export function isFavoriteProductCatalogId(catalogId: number): boolean {
  return getFavoriteProductCatalogIds().includes(catalogId);
}

export function setFavoriteProductCatalogIds(ids: number[]): void {
  if (typeof window === 'undefined' || !window.eventsTracking) return;
  try {
    const valid = ids.filter((id): id is number => typeof id === 'number' && Number.isInteger(id));
    const trimmed = valid.slice(-MAX_FAVORITES);
    window.eventsTracking.setData(FAVORITES_STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // ignore
  }
}

function addFavoriteWithLRU(catalogId: number): void {
  const ids = getFavoriteProductCatalogIds();
  const index = ids.indexOf(catalogId);
  let next: number[];
  if (index >= 0) {
    next = ids.filter((_, i) => i !== index);
    next.push(catalogId);
  } else {
    next = ids.length >= MAX_FAVORITES ? ids.slice(1) : [...ids];
    next.push(catalogId);
  }
  setFavoriteProductCatalogIds(next);
}

function removeFavorite(catalogId: number): void {
  const ids = getFavoriteProductCatalogIds().filter((id) => id !== catalogId);
  setFavoriteProductCatalogIds(ids);
}

export function toggleFavoriteProductCatalogId(catalogId: number): boolean {
  if (isFavoriteProductCatalogId(catalogId)) {
    removeFavorite(catalogId);
    return false;
  }
  addFavoriteWithLRU(catalogId);
  return true;
}
